<template>
  <v-layout class="select-drop-down-container">
    <select
      v-if="!$vuetify.breakpoint.mdAndUp"
      :value="valueId"
      @change="handleNativeInput"
      class="native-select">
      <option v-if="!valueId" value="" disabled>{{label}}</option>
      <option
      v-for="item in items"
      :value="item[itemValue]"
      v-if="item.hasOwnProperty(itemValue)"
      >
        {{item[itemText]}}
      </option>
    </select>
    <v-select
      :items="items"
      v-ds-click-outside="closeMenu"
      @click="openMenu = !openMenu"
      @input="openMenu = false"
      ref="selectCmp"
      :value="value"
      :label="label"
      :itemText="itemText"
      :itemValue="itemValue"
      v-bind="$attrs"
      v-on="$listeners"
      :return-object="returnObject"
      :hide-details="'auto'"
      :menuProps="menuProps"
      :class="{
    required: isRequired ,
    'select-drop-down': true,
    'custom-selection': !!$scopedSlots.selection,
    'has-value': !!$attrs.value,
  }"
      :style="{
    color: `${brandBgColor} !important`
  }"
    >
      <template v-if="$scopedSlots.selection" v-slot:selection="item">
        <slot name="selection" v-bind="item">
          <template></template>
        </slot>
      </template>

      <template v-if="$scopedSlots.item" v-slot:item="item">
        <slot name="item" v-bind="item">
          <template></template>
        </slot>
      </template>

      <template v-if="$scopedSlots['prepend-inner']" v-slot:prepend-inner>
        <slot name="prepend-inner">
          <template></template>
        </slot>
      </template>
    </v-select>
  </v-layout>

</template>

<script>
  export default {
    name: "VcitaSelectDropDown",
    props: {
      items: {
        type: Array,
        required: true,
      },
      itemText: {
        type: String,
        default: 'text'
      },
      itemValue: {
        type: String,
        default: 'value'
      },
      label: {
        type: String,
        default: '',
      },
      value: {
        type: [Object, String, Number],
        required: true
      }
    },
    data() {
      return {
        openMenu: false,
      }
    },
    methods: {
      closeMenu(event) {
        let isClickInside = !!event.target.closest('.v-menu__content')
        if (!isClickInside)
          this.openMenu = false
      },
      handleNativeInput(e) {
        let value = e.target.value
        if(this.returnObject) {
          value = this.items.find(item => item[this.itemValue] === value)
        }
        this.$emit('input', value)
      }
    },
    computed: {
      valueId() {
        return this.returnObject ? this.value[this.itemValue] : this.value
      },
      returnObject() {
        return this.$attrs['return-object'] || (this.$attrs.hasOwnProperty('return-object') && this.$attrs['return-object'] === '');
      },
      isRequired() {
        return [false, undefined].indexOf(this.$attrs.required) === -1
      },
      isDisabled() {
        return [false, undefined].indexOf(this.$attrs.disabled) === -1
      },
      brandBgColor() {
        return this.$store && this.$store.getters['brandModule/secondaryColor'];
      },
      menuProps() {
        let contentClass = 'select-drop-down-menu-content '
        const attrMenuProps = this.$attrs['menu-props'] || this.$attrs['menuProps']
        if(attrMenuProps) {
          if(attrMenuProps.contentClass) {
            contentClass += attrMenuProps.contentClass
          }
        }
        return {
          value: this.openMenu,
          'offset-y': true,
          ...this.$attrs['menu-props'],
          'close-on-click': true,
        ...{contentClass},
        }
      },
      popupItem() {
        this.openMenu
        return this.$refs.selectCmp && this.$refs.selectCmp.$refs.menu && this.$refs.selectCmp.$refs.menu.$refs.content
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";
  .select-drop-down-container {
    position: relative;
    font-family: var(--primary-font-family);
    border-radius: 6px;

    &.error--text {
      ::v-deep {
        .v-input__slot {
          border: 1px solid #F2514A;
        }
      }
    }
  }
  .native-select {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 7;
    opacity: 0;
  }
  .select-drop-down {
    font-family: var(--primary-font-family);
    font-size: 15px !important;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: -0.2px;
    height: 100%;
    border-radius: 6px;
    &.v-text-field--placeholder:not(.has-value) {
     ::v-deep {
       .v-select__slot {
         height: 49px;
       }
     }
    }
  }
  .v-input__control {
    height: 100%;
  }
  .list-label {
    font-family: var(--primary-font-family);
    font-size: 12px;
    font-weight: 500;
    line-height: 1.33;
    color: rgba(0, 0, 0, 0.54);
    margin-bottom: 3px;

    .required-astrix {
      color: #f2514a;
      font-weight: 600;
    }

    &.disabled {
      color: rgba(0, 0, 0, 0.3);
      .required-astrix {
        color: rgba(0, 0, 0, 0.3);
      }
    }
  }


</style>

<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";
  .select-drop-down-menu-content {
    .v-list-item__title {
      font-size: 14px;
    }
    .v-subheader {
      display: block;
      max-height: 1em;
      line-height: 1em;
      margin: 14px 0;
      font-size: 12px;
      font-weight: 500;
      height: 40px;
      color: rgba(0, 0, 0, 0.4);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .select-drop-down {
    margin: 0;
    padding: 0;
    .selection-item {
      width: 100%;
    }
    label {
      font-family: var(--primary-font-family);
      letter-spacing: -0.2px;
      color: rgba(0, 0, 0, 0.4) !important;
      font-size: 15px;
    }
    .v-select__slot:first-child {
      @include i-margin-mirror( 12px, 0 );
    }
    &[prepend-inner-icon] {
      .v-select__slot {
        padding: 0;
      }
    }

    &:not(.v-input--is-label-active):not(.v-input--is-focused) {
      .v-select__slot {
        height: 50px;
      }
      label {
        position: revert !important;
      }
    }
    &.v-input--is-label-active, &.v-input--is-focused  {

      label {
        font-family: var(--primary-font-family);
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: -0.3px;
        color: rgba(0, 0, 0, 0.62) !important;
        top: 8px;
        transform: translateY(-100%) scale(0.85);
      }
    }
    &:not(.v-text-field--outlined) {
      .v-select__slot {
        transition: margin-bottom 0.1s;
      }
    }
    .v-select__slot {
      color: rgba(0, 0, 0, 0.87);
    }
    &.v-select--is-menu-active {
      .v-input__slot {
        border-color: currentColor;
        box-shadow: 0 0 0 3px rgba(var(--brand-color-secondary-rgb), 0.4);
      }
    }
    .v-input__slot {
      min-height: 52px !important;
      border-radius: 6px;
      background-color: #fff !important;
      position: relative !important;
      border: solid 1px rgba(0, 0, 0, 0.12);
      transition: border-color,background-color 0.1s !important;
      align-items: flex-end;
      &:hover {
        border-color: #757575;
      }
      &:before, &:after {
        display: none;
      }
    }
    &.v-input--is-disabled {
      .v-input__slot {
        background-color: rgba(0, 0, 0, 0.03) !important;
      }
    }
    input {
      font-family: var(--primary-font-family);
      font-size: 15px !important;
      font-weight: 500;
    }
    .v-input__append-inner {
      position: absolute;
      min-height: 52px;
      @include i-position-mirror(right, 0);
      bottom: 0;
    }
    .v-input__prepend-inner, .v-input__append-inner {
      margin: auto 12px auto 12px !important;
      padding: 0 !important;

      .v-input__icon {
        margin: auto;

        i {
          font-size: 20px;
          color: rgba(0, 0, 0, 0.4) !important;
        }
      }

    }
    .v-select__selections {
      .v-list-item__title {
        font-family: var(--primary-font-family);
        font-size: 15px !important;
        font-weight: 500;
      }
    }

    .v-select__selection.v-select__selection--comma {
      font-weight: 500;
      margin: 0 1px;
    }
    fieldset {
      border: solid 1px rgba(0, 0, 0, 0.12);
    }
    &:hover:not(.error--text) {
      fieldset {
        border-color: rgba(0, 0, 0, 0.86);
      }
    }
    .v-list-item__content, .v-select__selection {
      text-transform: revert;
    }
  }

</style>
